export const departmentAssignmentHistoryColumnWidths = {
  taskId: '8%',
  type: '11%',
  taskType: '11%',
  asset: '12%',
  date: '8%',
  user: '10%',
  newDepartment: '10%',
  previousDepartment: '10%',
  isValidation: '5%',
  errors: '15%'
} as const;
